<style scoped lang="scss">
span.linebreak img.row {
  max-width: 100%;
}
</style>
<template>
  <span v-html="message.body"> </span>
</template>

<script>
export default {
  props: ["message"]
};
</script>
